import axios from '@/axios';
import coreIAMUrl from '@/apis/coreIAM'

export default {
    fetchAll() {
        return axios.get(`${coreIAMUrl}/admin/users`);
    },
    fetchOne(uuid) {
        return axios.get(`${coreIAMUrl}/admin/users/${uuid}`);
    },
    createUser(name) {
        return axios.post(`${coreIAMUrl}/admin/users`, { name: name });
    },
    updateUser(userUuid, name) {
        return axios.patch(`${coreIAMUrl}/admin/users/${userUuid}`, {
            name: name
        });
    },
    deleteUser(userUuid) {
        return axios.delete(`${coreIAMUrl}/admin/users/${userUuid}`);
    },
}